/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const TrackerIntroSlideFirstDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={152}
    height={140}
    fill="none"
    {...props}
    data-palette="TrackerIntroSlideFirstDark">
    <circle cx={74.464} cy={75.179} r={62.679} fill="#22242C" />
    <circle cx={15.714} cy={32.857} r={3.929} fill="#22242C" />
    <circle cx={119.107} cy={7.321} r={7.321} fill="#22242C" />
    <circle cx={16.964} cy={115.536} r={6.964} fill="#22242C" />
    <circle cx={141.607} cy={108.749} r={6.964} fill="#22242C" />
    <circle cx={128.035} cy={116.608} r={3.393} fill="#22242C" />
    <path
      fill="#22242C"
      d="m144.878 87.26 1.094 5.168 5.093 1.11-5.093 1.109-1.094 5.167-1.093-5.167-5.094-1.11 5.094-1.11 1.093-5.166ZM138.337 34.508c.08-.378.619-.378.699 0l.697 3.29a.357.357 0 0 0 .273.276l3.266.71c.375.083.375.617 0 .699l-3.266.711a.357.357 0 0 0-.273.275l-.697 3.29c-.08.378-.619.378-.699 0l-.696-3.29a.357.357 0 0 0-.273-.275l-3.266-.711c-.375-.082-.375-.616 0-.698l3.266-.711a.357.357 0 0 0 .273-.276l.696-3.29ZM8.651 77.722c.08-.378.619-.378.699 0l1.194 5.64c.029.138.136.245.273.275l5.582 1.216c.375.082.375.617 0 .698l-5.582 1.216a.357.357 0 0 0-.273.275l-1.194 5.64c-.08.378-.619.378-.699 0l-1.194-5.64a.357.357 0 0 0-.273-.275l-5.582-1.216c-.375-.082-.375-.616 0-.698l5.582-1.216a.357.357 0 0 0 .273-.275l1.194-5.64ZM30.902 17.692c-.207-.044-.207-.34 0-.384l3.13-.666a.196.196 0 0 0 .151-.15l.674-3.108c.045-.206.339-.206.384 0l.674 3.108a.196.196 0 0 0 .15.15l3.131.666c.207.044.207.34 0 .384l-3.13.666a.196.196 0 0 0-.151.15l-.674 3.108c-.045.206-.339.206-.384 0l-.674-3.108a.196.196 0 0 0-.15-.15l-3.131-.666Z"
    />
    <g clipPath="url(#a)">
      <path
        fill="#353845"
        d="M83.067 64.367c.03.11-.05.187-.165.165-2.248-.926-10.076-4.665-10.213-6.9 8.306 3.458 14.24-9.811 13.273-14.44-.518 2.578-5.522 5.798-7.775 5.294-.252-.056-3.094 3.28-2.233 3.888-1.113 1.717-2.226 10.14-3.64 10.67-.046.017-.113-.015-.165 0-5.673-1.803-10.416-1.126-13.895-7.03-2.308-3.919-.468-2.875 2.068-4.55 5.026-3.322 3.282-5.446 5.872-10.008 5.78-10.182 17.715-6.071 20.678-.662 3.516 6.419-1.448 15.224 4.136 22.167-2.523 1.073-7.396.89-8.023 1.075-.326.096.078.315.082.331Z"
      />
      <path
        fill="#F4AEAE"
        d="M64.572 48.16c0-6.29 5.099-11.388 11.388-11.388 6.29 0 11.389 5.098 11.389 11.388 0 5.1-3.354 9.417-7.977 10.867l-1.698 1.368 3.049 10.669-3.552 2.512-11.223-9.352s2.424-3.088 3.724-6.57a11.376 11.376 0 0 1-5.1-9.495ZM115.448 77.338l-8.16 28.353-8.25-5.727 9.723-24.737c-.848-1.57-1.059-3.635-.415-5.675 1.127-3.57 4.436-5.709 7.39-4.776 2.955.933 4.436 4.583 3.309 8.153-.644 2.04-2.002 3.61-3.597 4.409ZM88.217 88.533H58.785v34.28h29.432v-34.28Z"
      />
      <path
        fill="#E1E1E2"
        d="m68.665 61.198-6.997 15.978.692 27.46h23.647l.742-29.137-8.779-13.532-9.305-.769Z"
      />
      <path
        fill="#111114"
        d="M54.609 67.556s-2.049 58.756-7.549 68.452c0 0 7.601 1.324 9.534-1.415 1.933-2.74 9.39-20.977 9.47-25.016.081-4.039 2.417-48.398 2.417-48.398l-13.872 6.377ZM77.353 63.582l.618-1.614 15.682 6.227s-.732 58.717 5.617 64.651c0 0-10.606-.506-10.958-.749-.352-.243-8.052-30.606-8.052-30.606s3.67-14.065 3.954-20.071c.283-6.006-6.86-17.838-6.86-17.838Z"
      />
      <path
        fill="#111114"
        d="m56.978 109.943-6.676 20.286-.398 9.699h49.36l-9.52-29.985H56.979ZM89.674 69.343l3.979-1.148 9.149 18.53 3.921-10.15 9.688 2.769s-4.403 28.575-11.061 27.038c-6.657-1.537-15.676-17.23-15.676-17.23V69.344Z"
      />
      <path
        fill="#F4AEAE"
        d="m50.449 125.928-13.353-19.412 6.138-5.401 12.548 21.128c1.628.271 3.254 1.288 4.379 2.915 1.967 2.847 1.652 6.475-.704 8.104-2.357 1.628-5.862.64-7.83-2.208-1.124-1.627-1.5-3.508-1.178-5.126Z"
      />
      <path
        fill="#111114"
        d="m56.978 69.195-2.37-1.638-19.389 36.621s-1.574 2.208.48 5.766c2.052 3.558 12.59 14.454 12.59 14.454l8.304-4.69-8.457-15.761 7.972-13.79.87-20.962Z"
      />
      <path
        fill="#353845"
        d="M85.962 43.194c-.518 2.577-10.87 8.573-10.008 9.18-1.113 1.718-2.226 10.142-3.64 10.67-.046.018-.113-.014-.165 0-5.673-1.802-10.416-1.125-13.895-7.03-2.308-3.918-.468-2.874 2.068-4.55 5.026-3.32 3.282-5.445 5.872-10.007 5.78-10.182 17.715-6.071 20.678-.662 3.516 6.419.057 7.027-.91 2.399Z"
      />
      <path
        fill="#FE6C02"
        d="M130.388 39.018c0 1.236-.111 2.47-.329 3.67a18.011 18.011 0 0 1-1.783 4.422c-1.51 2.68-3.127 3.681-4.456 6.306-.229.176-.464.336-.703.491-.478.309-.53 1.818-1.039 2.078-.003.003-.007.003-.01.007-.094.066-.18.388-.263.873v.006c-.257 1.5-.478 4.55-.734 6.354-.035.218-.066.42-.101.596-.086.478-.176.782-.277.82-1.236.478-1.762-.176-3.116 0-.727.097-4.439.693-5.194.693-2.143 0-3.303-.73-5.038-1.513-.121-.052-.243-.108-.371-.163-.045-.017-.086-.038-.131-.055-.499-.212-.97-5.537-1.437-7.552-.004-.004-.004-.007-.004-.01-.097-.42-.194-.693-.29-.748a13.65 13.65 0 0 1-.977-.613c-1.783-2.971-5.228-5.797-6.929-10.42-.488-1.734-.75-3.514-.75-5.242 0-9.37 7.596-16.966 16.966-16.966 9.369 0 16.966 7.597 16.966 16.966Z"
      />
      <path
        fill="#111114"
        d="M130.059 42.688a18.011 18.011 0 0 1-1.783 4.422c-1.51 2.68-3.127 3.68-4.456 6.306-.883 1.748-1.642 4.217-2.154 8.379-.031.246.035.526 0 .769-.08.536.017.44-.308.924-.149.083-.239-.035-.288-.263-.09-.384-.065-1.094-.02-1.738.117-1.76.384-3.283.754-4.616v-.007c.083-.301.174-.592.264-.872 1.603-4.883 4.56-7.095 5.9-9.65 7.039-13.394-5.97-28.345-20.298-23.144-.769.28-.727.443-.769.464-1.076.467-1.952.671-2.998 1.381-6.35 4.322-8.629 12.87-5.765 19.913 1.551 3.813 4.799 5.963 6.901 10.295a17.794 17.794 0 0 1 .367.8c.845 1.984 1.444 4.418 1.568 7.607.004.045.007.09.007.135.125.01.246.017.364.028 1.838.159 3.029.453 3.646.135l.678.069c.226.315 4.007-.07 4.613-.076h.155c1.507-.021 3.027.055 4.533-.128.076-.007.156-.018.232-.028.391.11.287.443.308.464.049.436-.675 1.7-.921 1.842-.71.415-12.275.627-13.379-.152-1.167-.825-.592-1.964-.613-2.075-.021-.096-.447-.373-.464-.464-.208-1.177.038-4.165-1.382-7.534a9.007 9.007 0 0 0-.616-1.195c-1.783-2.97-5.229-5.796-6.929-10.419-.79-2.14-1.205-4.66-.914-7.76.613-6.509 6.229-12.915 12.531-14.532 13.189-3.386 24.325 8.574 21.236 20.72Z"
      />
      <path
        fill="#111114"
        d="M120.754 66.458c1.097 1.044.511 1.397 0 2.614-.645-.145-11.686.56-13.224 0-1.032-.376-1.325-1.731-.462-2.614 4.398.499 9.308.517 13.686 0Z"
      />
      <path
        fill="#111114"
        d="M121.369 69.534c.432.96-.395 1.55-.769 2.307l-.769.153-12.148-.153c-.732-.141-1.194-1.165-1.383-1.846.022-.011-.087-.247.23-.46l1-.308c3.154.306 8.922.446 12.071.307.093-.004.609-.51 1.768 0Z"
      />
      <path
        fill="#FE6C02"
        d="M113.332 12.956c.651-.444.663 4.751.462 4.92-.76.64-.68-4.772-.462-4.92ZM108.103 13.417c.512-.329 1.691 4.589 1.615 4.844-.434 1.448-1.855-4.69-1.615-4.844ZM118.56 13.417c.61-.16-.416 4.622-.538 4.844-1.153 2.098.207-4.757.538-4.844Z"
      />
      <path
        fill="#111114"
        d="M111.403 57.024h-.319v-5.209l-5.871-12.433.288-.136 5.902 12.498v5.28ZM116.365 57.03l-.261-5.786.005-.022 3.116-12.812.31.076-3.111 12.789.259 5.741-.318.015Z"
      />
      <path
        fill="#22242C"
        d="M147.148 139.929H8.84c-.448-.04-.78-.488-.75-1.003-.03-.51.302-.958.75-.997h138.308c.395.056.706.414.755.868.063.555-.273 1.058-.755 1.132Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M8.445 12.929h139.823v127H8.445z" />
      </clipPath>
    </defs>
  </svg>
);

const TrackerIntroSlideFirstLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={152}
    height={140}
    fill="none"
    {...props}
    data-palette="TrackerIntroSlideFirstLight">
    <circle cx={74.464} cy={75.179} r={62.679} fill="#F3F4F6" />
    <circle cx={15.714} cy={32.857} r={3.929} fill="#F3F4F6" />
    <circle cx={119.107} cy={7.321} r={7.321} fill="#F3F4F6" />
    <circle cx={16.964} cy={115.536} r={6.964} fill="#F3F4F6" />
    <circle cx={141.607} cy={108.749} r={6.964} fill="#F3F4F6" />
    <circle cx={128.035} cy={116.608} r={3.393} fill="#F3F4F6" />
    <path
      fill="#F3F4F6"
      d="m144.878 87.26 1.094 5.168 5.093 1.11-5.093 1.109-1.094 5.167-1.093-5.167-5.094-1.11 5.094-1.11 1.093-5.166ZM138.337 34.508c.08-.378.619-.378.699 0l.697 3.29a.357.357 0 0 0 .273.276l3.266.71c.375.083.375.617 0 .699l-3.266.711a.357.357 0 0 0-.273.275l-.697 3.29c-.08.378-.619.378-.699 0l-.696-3.29a.357.357 0 0 0-.273-.275l-3.266-.711c-.375-.082-.375-.616 0-.698l3.266-.711a.357.357 0 0 0 .273-.276l.696-3.29ZM8.651 77.722c.08-.378.619-.378.699 0l1.194 5.64c.029.138.136.245.273.275l5.582 1.216c.375.082.375.617 0 .698l-5.582 1.216a.357.357 0 0 0-.273.275l-1.194 5.64c-.08.378-.619.378-.699 0l-1.194-5.64a.357.357 0 0 0-.273-.275l-5.582-1.216c-.375-.082-.375-.616 0-.698l5.582-1.216a.357.357 0 0 0 .273-.275l1.194-5.64ZM30.902 17.692c-.207-.044-.207-.34 0-.384l3.13-.666a.196.196 0 0 0 .151-.15l.674-3.108c.045-.206.339-.206.384 0l.674 3.108a.196.196 0 0 0 .15.15l3.131.666c.207.044.207.34 0 .384l-3.13.666a.196.196 0 0 0-.151.15l-.674 3.108c-.045.206-.339.206-.384 0l-.674-3.108a.196.196 0 0 0-.15-.15l-3.131-.666Z"
    />
    <g clipPath="url(#a)">
      <path
        fill="#121214"
        d="M83.067 64.367c.03.11-.05.187-.165.165-2.248-.926-10.076-4.665-10.213-6.9 8.306 3.458 14.24-9.811 13.273-14.44-.518 2.578-5.522 5.798-7.775 5.294-.252-.056-3.094 3.28-2.233 3.888-1.113 1.717-2.226 10.14-3.64 10.67-.046.017-.113-.015-.165 0-5.673-1.803-10.416-1.126-13.895-7.03-2.308-3.919-.468-2.875 2.068-4.55 5.026-3.322 3.282-5.446 5.872-10.008 5.78-10.182 17.715-6.071 20.678-.662 3.516 6.419-1.448 15.224 4.136 22.167-2.523 1.073-7.396.89-8.023 1.075-.326.096.078.315.082.331Z"
      />
      <path
        fill="#F4AEAE"
        d="M64.572 48.16c0-6.29 5.099-11.388 11.388-11.388 6.29 0 11.389 5.098 11.389 11.388 0 5.1-3.354 9.417-7.977 10.867l-1.698 1.368 3.049 10.669-3.552 2.512-11.223-9.352s2.424-3.088 3.724-6.57a11.376 11.376 0 0 1-5.1-9.495ZM115.448 77.338l-8.16 28.353-8.25-5.727 9.723-24.737c-.848-1.57-1.059-3.635-.415-5.675 1.127-3.57 4.436-5.709 7.39-4.776 2.955.933 4.436 4.583 3.309 8.153-.644 2.04-2.002 3.61-3.597 4.409ZM88.217 88.533H58.785v34.28h29.432v-34.28Z"
      />
      <path
        fill="#121214"
        d="m68.665 61.198-6.997 15.978.692 27.46h23.647l.742-29.137-8.779-13.532-9.305-.769Z"
      />
      <path
        fill="#ADB1B7"
        d="M54.609 67.556s-2.049 58.756-7.549 68.452c0 0 7.601 1.324 9.534-1.415 1.933-2.74 9.39-20.977 9.47-25.016.081-4.039 2.417-48.398 2.417-48.398l-13.872 6.377ZM77.353 63.582l.618-1.614 15.682 6.227s-.732 58.717 5.617 64.651c0 0-10.606-.506-10.958-.749-.352-.243-8.052-30.606-8.052-30.606s3.67-14.065 3.954-20.071c.283-6.006-6.86-17.838-6.86-17.838Z"
      />
      <path
        fill="#ADB1B7"
        d="m56.978 109.943-6.676 20.286-.398 9.699h49.36l-9.52-29.985H56.979ZM89.674 69.343l3.979-1.148 9.149 18.53 3.921-10.15 9.688 2.769s-4.403 28.575-11.061 27.038c-6.657-1.537-15.676-17.23-15.676-17.23V69.344Z"
      />
      <path
        fill="#F4AEAE"
        d="m50.449 125.928-13.353-19.412 6.138-5.401 12.548 21.128c1.628.271 3.254 1.288 4.379 2.915 1.967 2.847 1.652 6.475-.704 8.104-2.357 1.628-5.862.64-7.83-2.208-1.124-1.627-1.5-3.508-1.178-5.126Z"
      />
      <path
        fill="#ADB1B7"
        d="m56.978 69.195-2.37-1.638-19.389 36.621s-1.574 2.208.48 5.766c2.052 3.558 12.59 14.454 12.59 14.454l8.304-4.69-8.457-15.761 7.972-13.79.87-20.962Z"
      />
      <path
        fill="#121214"
        d="M85.962 43.194c-.518 2.577-10.87 8.573-10.008 9.18-1.113 1.718-2.226 10.142-3.64 10.67-.046.018-.113-.014-.165 0-5.673-1.802-10.416-1.125-13.895-7.03-2.308-3.918-.468-2.874 2.068-4.55 5.026-3.32 3.282-5.445 5.872-10.007 5.78-10.182 17.715-6.071 20.678-.662 3.516 6.419.057 7.027-.91 2.399Z"
      />
      <path
        fill="#FE6C02"
        d="M130.388 39.018c0 1.236-.111 2.47-.329 3.67a18.011 18.011 0 0 1-1.783 4.422c-1.51 2.68-3.127 3.681-4.456 6.306-.229.176-.464.336-.703.491-.478.309-.53 1.818-1.039 2.078-.003.003-.007.003-.01.007-.094.066-.18.388-.263.873v.006c-.257 1.5-.478 4.55-.734 6.354-.035.218-.066.42-.101.596-.086.478-.176.782-.277.82-1.236.478-1.762-.176-3.116 0-.727.097-4.439.693-5.194.693-2.143 0-3.303-.73-5.038-1.513-.121-.052-.243-.108-.371-.163-.045-.017-.086-.038-.131-.055-.499-.212-.97-5.537-1.437-7.552-.004-.004-.004-.007-.004-.01-.097-.42-.194-.693-.29-.748a13.65 13.65 0 0 1-.977-.613c-1.783-2.971-5.228-5.797-6.929-10.42-.488-1.734-.75-3.514-.75-5.242 0-9.37 7.596-16.966 16.966-16.966 9.369 0 16.966 7.597 16.966 16.966Z"
      />
      <path
        fill="#121214"
        d="M130.059 42.688a18.011 18.011 0 0 1-1.783 4.422c-1.51 2.68-3.127 3.68-4.456 6.306-.883 1.748-1.642 4.217-2.154 8.379-.031.246.035.526 0 .769-.08.536.017.44-.308.924-.149.083-.239-.035-.288-.263-.09-.384-.065-1.094-.02-1.738.117-1.76.384-3.283.754-4.616v-.007c.083-.301.174-.592.264-.872 1.603-4.883 4.56-7.095 5.9-9.65 7.039-13.394-5.97-28.345-20.298-23.144-.769.28-.727.443-.769.464-1.076.467-1.952.671-2.998 1.381-6.35 4.322-8.629 12.87-5.765 19.913 1.551 3.813 4.799 5.963 6.901 10.295a17.794 17.794 0 0 1 .367.8c.845 1.984 1.444 4.418 1.568 7.607.004.045.007.09.007.135.125.01.246.017.364.028 1.838.159 3.029.453 3.646.135l.678.069c.226.315 4.007-.07 4.613-.076h.155c1.507-.021 3.027.055 4.533-.128.076-.007.156-.018.232-.028.391.11.287.443.308.464.049.436-.675 1.7-.921 1.842-.71.415-12.275.627-13.379-.152-1.167-.825-.592-1.964-.613-2.075-.021-.096-.447-.373-.464-.464-.208-1.177.038-4.165-1.382-7.534a9.007 9.007 0 0 0-.616-1.195c-1.783-2.97-5.229-5.796-6.929-10.419-.79-2.14-1.205-4.66-.914-7.76.613-6.509 6.229-12.915 12.531-14.532 13.189-3.386 24.325 8.574 21.236 20.72Z"
      />
      <path
        fill="#121214"
        d="M120.754 66.458c1.097 1.044.511 1.397 0 2.614-.645-.145-11.686.56-13.224 0-1.032-.376-1.325-1.731-.462-2.614 4.398.499 9.308.517 13.686 0Z"
      />
      <path
        fill="#121214"
        d="M121.369 69.534c.432.96-.395 1.55-.769 2.307l-.769.153-12.148-.153c-.732-.141-1.194-1.165-1.383-1.846.022-.011-.087-.247.23-.46l1-.308c3.154.306 8.922.446 12.071.307.093-.004.609-.51 1.768 0Z"
      />
      <path
        fill="#FE6C02"
        d="M113.332 12.956c.651-.444.663 4.751.462 4.92-.76.64-.68-4.772-.462-4.92ZM108.103 13.417c.512-.329 1.691 4.589 1.615 4.844-.434 1.448-1.855-4.69-1.615-4.844ZM118.56 13.417c.61-.16-.416 4.622-.538 4.844-1.153 2.098.207-4.757.538-4.844Z"
      />
      <path
        fill="#EBECF0"
        d="M111.403 57.024h-.319v-5.209l-5.871-12.433.288-.136 5.902 12.498v5.28ZM116.365 57.03l-.261-5.786.005-.022 3.116-12.812.31.076-3.111 12.789.259 5.741-.318.015Z"
      />
      <path
        fill="#F3F4F6"
        d="M147.148 139.929H8.84c-.448-.04-.78-.488-.75-1.003-.03-.51.302-.958.75-.997h138.308c.395.056.706.414.755.868.063.555-.273 1.058-.755 1.132Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M8.445 12.929h139.823v127H8.445z" />
      </clipPath>
    </defs>
  </svg>
);

const TrackerIntroSlideSecondDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={156}
    fill="none"
    {...props}
    data-palette="TrackerIntroSlideSecondDark">
    <circle cx={118.757} cy={88.25} r={62.679} fill="#22242C" />
    <circle cx={60.007} cy={45.929} r={3.929} fill="#22242C" />
    <circle cx={61.257} cy={128.607} r={6.964} fill="#22242C" />
    <circle cx={185.9} cy={121.822} r={6.964} fill="#22242C" />
    <circle cx={172.328} cy={129.679} r={3.393} fill="#22242C" />
    <path
      fill="#22242C"
      d="m189.171 100.332 1.094 5.167 5.093 1.109-5.093 1.11-1.094 5.167-1.094-5.167-5.093-1.11 5.093-1.109 1.094-5.167ZM182.63 47.58c.08-.378.619-.378.699 0l.697 3.29a.357.357 0 0 0 .273.275l3.266.711c.375.082.375.616 0 .698l-3.266.712a.357.357 0 0 0-.273.275l-.697 3.29c-.08.377-.619.377-.699 0l-.696-3.29a.357.357 0 0 0-.273-.275l-3.266-.712c-.375-.082-.375-.616 0-.698l3.266-.711a.357.357 0 0 0 .273-.275l.696-3.29ZM52.944 90.793c.08-.377.619-.377.699 0l1.194 5.64c.029.138.136.246.273.275l5.582 1.216c.375.082.375.617 0 .698l-5.582 1.216a.357.357 0 0 0-.273.275l-1.194 5.641c-.08.377-.62.377-.699 0l-1.194-5.641a.357.357 0 0 0-.273-.275l-5.582-1.216c-.375-.081-.375-.616 0-.698l5.582-1.216a.357.357 0 0 0 .273-.275l1.194-5.64ZM75.195 30.763c-.207-.044-.207-.34 0-.384l3.13-.665a.196.196 0 0 0 .151-.15l.674-3.109c.045-.206.339-.206.384 0l.674 3.109a.196.196 0 0 0 .15.15l3.131.666c.207.044.207.339 0 .383l-3.13.666a.196.196 0 0 0-.151.15l-.674 3.109c-.045.206-.339.206-.384 0l-.674-3.109a.196.196 0 0 0-.15-.15l-3.131-.666Z"
    />
    <g clipPath="url(#a)">
      <path
        fill="#A0616A"
        d="M100.161 48.356s-3.555 15.01.79 15.01c4.344 0 14.614-16.985 14.614-16.985l-3.555-4.345-6.38 8.859-.335-4.514-5.134 1.975Z"
      />
      <path
        fill="#F4AEAE"
        d="M114.619 47.034a3.458 3.458 0 1 0 0-6.916 3.458 3.458 0 0 0 0 6.916ZM97.147 150.585l4.604-.001 2.19-17.756h-6.794v17.757Z"
      />
      <path
        fill="#353845"
        d="M96.985 155.386h14.156v-.179a5.511 5.511 0 0 0-5.51-5.51h-.001l-2.585-1.962-4.825 1.962h-1.236v5.689Z"
      />
      <path
        fill="#F4AEAE"
        d="m47.629 144.841 4.119 2.055 9.889-14.909-6.08-3.034-7.928 15.888Z"
      />
      <path
        fill="#353845"
        d="m45.34 149.065 12.666 6.321.08-.16a5.51 5.51 0 0 0-2.47-7.391l-1.437-2.91-5.193-.399-1.106-.551-2.54 5.09Z"
      />
      <path fill="#22242C" d="M151.596 155.404H0V156h151.596v-.596Z" />
      <path
        fill="#111114"
        d="m67.385 75.585-2.235 26.86a33.715 33.715 0 0 1-1.975 8.69s-.79 1.58-.79 3.16l-8.953 16.271s-2.736 2.011-2.341 3.591-1.65 2.528-1.65 2.528l9.429 1.817s-.395-1.185.79-1.58 2.128-3.821 2.128-3.821l13.237-21.571 9.48-19.75s5.53 17.775 6.714 19.75c0 0 4.345 22.119 5.135 24.094.79 1.975 1.185 1.975.79 2.765s-.395 1.58 0 1.975 7.9 0 7.9 0l-1.975-28.044-3.555-33.574-18.17-5.53-13.96 2.37Z"
      />
      <path
        fill="#F4AEAE"
        d="M85.174 22.78a8.295 8.295 0 1 0 0-16.59 8.295 8.295 0 0 0 0 16.59Z"
      />
      <path
        fill="#E1E1E2"
        d="m100.303 34.902-9.874-5.982s-.274-3.715-3.088-3.89a2954.3 2954.3 0 0 1-6.712-.427c-.673-.043-1.126 3.634-1.897 3.584L68.31 30.953l1.58 26.86s-2.37 10.665-1.58 12.64c.79 1.974-1.975 2.764-1.185 3.16.79.394 0 3.16 0 3.16s15.405 7.899 32.39 1.974l-1.58-5.135a4.144 4.144 0 0 0-.79-3.95s1.58-2.37-.396-4.344c0 0 .79-3.555-1.185-5.135l-.395-5.53 1.185-2.765 3.95-16.985Z"
      />
      <path
        fill="#353845"
        d="m77.976 19.224-.232-.538c-.03-.07-2.963-7.005-.363-11.282 1.204-1.98 3.392-3.098 6.505-3.323 4.87-.352 8.203.803 9.91 3.432a2.946 2.946 0 0 1-2.484 4.538h-.065l-.895-1.162-.052.113c-.324.701-1.068 1.085-1.94 1.001-.148-.01-.28.117-.385.391a.695.695 0 0 1-.52.483c-.644.125-1.562-.686-1.973-1.09a.66.66 0 0 1-.308.452c-.432.25-1.106-.076-1.3-.18-1.54.327-2.538.24-2.965-.26-.29 2.05-.911 5.738-1.657 5.943a.372.372 0 0 1-.406-.178c-.18-.233-.34-.35-.44-.317-.243.077-.386.876-.407 1.391l-.023.586Z"
      />
      <path
        fill="#E1E1E2"
        d="m95.96 35.297 3.94-.64a19.238 19.238 0 0 1 5.539 10.12c1.185 6.32 1.58 7.505 1.58 7.505l-9.48 2.37-5.135-9.875 3.555-9.48Z"
      />
      <path
        fill="#fff"
        d="M78.474 43.517 76.04 74.386l62.14 4.902 2.435-30.869-62.14-4.901Z"
      />
      <path
        fill="#FE6C02"
        d="M85.113 45.91c-1.52-1.087-3.452-1.165-4.19-1.15.226.703.925 2.504 2.446 3.59 1.524 1.09 3.453 1.165 4.189 1.15-.225-.702-.924-2.504-2.445-3.59ZM91.112 65.55l-9.978-.786a2.254 2.254 0 0 0-1.89 3.707 2.252 2.252 0 0 0 1.536.783l9.978.787a2.252 2.252 0 0 0 .354-4.49Z"
      />
      <path
        fill="#353845"
        d="m138.166 45.419-55.943-4.413a4.97 4.97 0 0 0-5.345 4.564l-2.152 27.255a4.973 4.973 0 0 0 4.566 5.348l55.943 4.413a4.971 4.971 0 0 0 5.345-4.565l2.044-25.904.041-.53.065-.823a4.968 4.968 0 0 0-4.564-5.345Zm-1.652 23.713-.355 4.49a3.012 3.012 0 0 1-3.23 2.757l-7.484-.59a3.012 3.012 0 0 1-2.756-3.23l.354-4.49a3.008 3.008 0 0 1 3.23-2.757l7.482.59a3.014 3.014 0 0 1 2.759 3.23Zm-58.296-2.341a2.753 2.753 0 0 1 2.957-2.525l9.977.787a2.75 2.75 0 1 1-.428 5.487h-.005l-9.977-.787a2.75 2.75 0 0 1-2.524-2.962Zm2.136-22.209-.068-.279.287-.026c.112-.012 2.766-.25 4.832 1.225 2.066 1.476 2.7 4.066 2.727 4.174l.066.28-.286.028a7.55 7.55 0 0 1-1.221-.008 7.22 7.22 0 0 1-3.612-1.22c-2.066-1.475-2.7-4.065-2.725-4.174Z"
      />
      <path
        fill="#FE6C02"
        d="m128.119 72.11-3.242-.256a.875.875 0 0 0-.138 1.746l3.243.256a.875.875 0 0 0 .137-1.746ZM134.107 72.583l-3.243-.256a.876.876 0 0 0-.137 1.746l3.242.256a.878.878 0 0 0 .94-.805.878.878 0 0 0-.802-.941ZM128.297 69.865l-3.243-.256a.875.875 0 0 0-.138 1.746l3.243.256a.874.874 0 0 0 .94-.804.874.874 0 0 0-.802-.942ZM134.284 70.338l-3.243-.256a.876.876 0 0 0-.138 1.746l3.243.256a.874.874 0 0 0 .94-.805.878.878 0 0 0-.802-.941ZM128.473 67.62l-3.243-.256a.875.875 0 0 0-.137 1.746l3.242.256a.878.878 0 0 0 .94-.805.878.878 0 0 0-.802-.941ZM134.461 68.092l-3.243-.255a.876.876 0 0 0-.138 1.746l3.243.255a.876.876 0 0 0 .138-1.746Z"
      />
      <path fill="#111114" d="m76.046 54.17-.042.53 65.67 5.159.041-.53-65.67-5.16Z" />
      <g filter="url(#b)">
        <path
          fill="#2D303A"
          d="m142.665 51.588-.041.53-2.285-.18-24.351-1.913.044-.53 24.348 1.913 2.285.18Z"
        />
      </g>
      <path
        fill="#F4AEAE"
        d="M62.385 45.962s-3.555 15.01.79 15.01c4.345 0 14.615-16.985 14.615-16.985l-3.555-4.344-6.38 8.858-.335-4.514-5.135 1.975Z"
      />
      <path
        fill="#F4AEAE"
        d="M76.841 44.64a3.458 3.458 0 1 0 0-6.917 3.458 3.458 0 0 0 0 6.916Z"
      />
      <path
        fill="#E1E1E2"
        d="m71.187 33.322-2.37-2.37s-4.74 2.765-5.135 5.53c-.395 2.765-2.37 11.455-2.37 11.455l7.308.592 2.37-3.555.197-11.652Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h240.585v156H0z" />
      </clipPath>
      <filter
        id="b"
        width={34.678}
        height={10.622}
        x={111.988}
        y={49.495}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1744_13787" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1744_13787" result="shape" />
      </filter>
    </defs>
  </svg>
);

const TrackerIntroSlideSecondLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={156}
    fill="none"
    {...props}
    data-palette="TrackerIntroSlideSecondLight">
    <circle cx={118.757} cy={88.25} r={62.679} fill="#F3F4F6" />
    <circle cx={60.007} cy={45.929} r={3.929} fill="#F3F4F6" />
    <circle cx={61.257} cy={128.607} r={6.964} fill="#F3F4F6" />
    <circle cx={185.9} cy={121.822} r={6.964} fill="#F3F4F6" />
    <circle cx={172.328} cy={129.679} r={3.393} fill="#F3F4F6" />
    <path
      fill="#F3F4F6"
      d="m189.171 100.332 1.094 5.167 5.093 1.109-5.093 1.11-1.094 5.167-1.094-5.167-5.093-1.11 5.093-1.109 1.094-5.167ZM182.63 47.58c.08-.378.619-.378.699 0l.697 3.29a.357.357 0 0 0 .273.275l3.266.711c.375.082.375.616 0 .698l-3.266.712a.357.357 0 0 0-.273.275l-.697 3.29c-.08.377-.619.377-.699 0l-.696-3.29a.357.357 0 0 0-.273-.275l-3.266-.712c-.375-.082-.375-.616 0-.698l3.266-.711a.357.357 0 0 0 .273-.275l.696-3.29ZM52.944 90.793c.08-.377.619-.377.699 0l1.194 5.64c.029.138.136.246.273.275l5.582 1.216c.375.082.375.617 0 .698l-5.582 1.216a.357.357 0 0 0-.273.275l-1.194 5.641c-.08.377-.62.377-.699 0l-1.194-5.641a.357.357 0 0 0-.273-.275l-5.582-1.216c-.375-.081-.375-.616 0-.698l5.582-1.216a.357.357 0 0 0 .273-.275l1.194-5.64ZM75.195 30.763c-.207-.044-.207-.34 0-.384l3.13-.665a.196.196 0 0 0 .151-.15l.674-3.109c.045-.206.339-.206.384 0l.674 3.109a.196.196 0 0 0 .15.15l3.131.666c.207.044.207.339 0 .383l-3.13.666a.196.196 0 0 0-.151.15l-.674 3.109c-.045.206-.339.206-.384 0l-.674-3.109a.196.196 0 0 0-.15-.15l-3.131-.666Z"
    />
    <g clipPath="url(#a)">
      <path
        fill="#A0616A"
        d="M100.161 48.356s-3.555 15.01.79 15.01c4.344 0 14.614-16.985 14.614-16.985l-3.555-4.345-6.38 8.859-.335-4.514-5.134 1.975Z"
      />
      <path
        fill="#F4AEAE"
        d="M114.619 47.034a3.458 3.458 0 1 0 0-6.916 3.458 3.458 0 0 0 0 6.916ZM97.147 150.585l4.604-.001 2.19-17.756h-6.794v17.757Z"
      />
      <path
        fill="#121214"
        d="M96.985 155.386h14.156v-.179a5.511 5.511 0 0 0-5.51-5.51h-.001l-2.585-1.962-4.825 1.962h-1.236v5.689Z"
      />
      <path
        fill="#F4AEAE"
        d="m47.629 144.841 4.119 2.055 9.889-14.909-6.08-3.034-7.928 15.888Z"
      />
      <path
        fill="#121214"
        d="m45.34 149.065 12.666 6.321.08-.16a5.51 5.51 0 0 0-2.47-7.391l-1.437-2.91-5.193-.399-1.106-.551-2.54 5.09Z"
      />
      <path fill="#F3F4F6" d="M151.596 155.404H0V156h151.596v-.596Z" />
      <path
        fill="#ADB1B7"
        d="m67.385 75.585-2.235 26.86a33.715 33.715 0 0 1-1.975 8.69s-.79 1.58-.79 3.16l-8.953 16.271s-2.736 2.011-2.341 3.591-1.65 2.528-1.65 2.528l9.429 1.817s-.395-1.185.79-1.58 2.128-3.821 2.128-3.821l13.237-21.571 9.48-19.75s5.53 17.775 6.714 19.75c0 0 4.345 22.119 5.135 24.094.79 1.975 1.185 1.975.79 2.765s-.395 1.58 0 1.975 7.9 0 7.9 0l-1.975-28.044-3.555-33.574-18.17-5.53-13.96 2.37Z"
      />
      <path
        fill="#F4AEAE"
        d="M85.174 22.78a8.295 8.295 0 1 0 0-16.59 8.295 8.295 0 0 0 0 16.59Z"
      />
      <path
        fill="#121214"
        d="m100.303 34.902-9.874-5.982s-.274-3.715-3.088-3.89a2954.3 2954.3 0 0 1-6.712-.427c-.673-.043-1.126 3.634-1.897 3.584L68.31 30.953l1.58 26.86s-2.37 10.665-1.58 12.64c.79 1.974-1.975 2.764-1.185 3.16.79.394 0 3.16 0 3.16s15.405 7.899 32.39 1.974l-1.58-5.135a4.144 4.144 0 0 0-.79-3.95s1.58-2.37-.396-4.344c0 0 .79-3.555-1.185-5.135l-.395-5.53 1.185-2.765 3.95-16.985ZM77.976 19.224l-.232-.538c-.03-.07-2.963-7.005-.363-11.282 1.204-1.98 3.392-3.098 6.505-3.323 4.87-.352 8.203.803 9.91 3.432a2.946 2.946 0 0 1-2.484 4.538h-.065l-.895-1.162-.052.113c-.324.701-1.068 1.085-1.94 1.001-.148-.01-.28.117-.385.391a.695.695 0 0 1-.52.483c-.644.125-1.562-.686-1.973-1.09a.66.66 0 0 1-.308.452c-.432.25-1.106-.076-1.3-.18-1.54.327-2.538.24-2.965-.26-.29 2.05-.911 5.738-1.657 5.943a.373.373 0 0 1-.406-.178c-.18-.233-.34-.35-.44-.317-.243.077-.386.876-.407 1.391l-.023.586Z"
      />
      <path
        fill="#121214"
        d="m95.96 35.297 3.94-.64a19.238 19.238 0 0 1 5.539 10.12c1.185 6.32 1.58 7.505 1.58 7.505l-9.48 2.37-5.135-9.875 3.555-9.48Z"
      />
      <path
        fill="#fff"
        d="M78.474 43.517 76.04 74.386l62.14 4.902 2.435-30.869-62.14-4.901Z"
      />
      <path
        fill="#FE6C02"
        d="M85.113 45.91c-1.52-1.087-3.452-1.165-4.19-1.15.226.703.925 2.504 2.446 3.59 1.524 1.09 3.453 1.165 4.189 1.15-.225-.702-.924-2.504-2.445-3.59ZM91.112 65.55l-9.978-.786a2.254 2.254 0 0 0-1.89 3.707 2.252 2.252 0 0 0 1.536.783l9.978.787a2.252 2.252 0 0 0 .354-4.49Z"
      />
      <path
        fill="#8E9298"
        d="m138.166 45.419-55.943-4.413a4.97 4.97 0 0 0-5.345 4.564l-2.152 27.255a4.973 4.973 0 0 0 4.566 5.348l55.943 4.413a4.971 4.971 0 0 0 5.345-4.565l2.044-25.904.041-.53.065-.823a4.968 4.968 0 0 0-4.564-5.345Zm-1.652 23.713-.355 4.49a3.012 3.012 0 0 1-3.23 2.757l-7.484-.59a3.012 3.012 0 0 1-2.756-3.23l.354-4.49a3.008 3.008 0 0 1 3.23-2.757l7.482.59a3.014 3.014 0 0 1 2.759 3.23Zm-58.296-2.341a2.753 2.753 0 0 1 2.957-2.525l9.977.787a2.75 2.75 0 1 1-.428 5.487h-.005l-9.977-.787a2.75 2.75 0 0 1-2.524-2.962Zm2.136-22.209-.068-.279.287-.026c.112-.012 2.766-.25 4.832 1.225 2.066 1.476 2.7 4.066 2.727 4.174l.066.28-.286.028a7.55 7.55 0 0 1-1.221-.008 7.22 7.22 0 0 1-3.612-1.22c-2.066-1.475-2.7-4.065-2.725-4.174Z"
      />
      <path
        fill="#FE6C02"
        d="m128.119 72.11-3.242-.256a.875.875 0 0 0-.138 1.746l3.243.256a.875.875 0 0 0 .137-1.746ZM134.107 72.583l-3.243-.256a.876.876 0 0 0-.137 1.746l3.242.256a.878.878 0 0 0 .94-.805.878.878 0 0 0-.802-.941ZM128.297 69.865l-3.243-.256a.875.875 0 0 0-.138 1.746l3.243.256a.874.874 0 0 0 .94-.804.874.874 0 0 0-.802-.942ZM134.284 70.338l-3.243-.256a.876.876 0 0 0-.138 1.746l3.243.256a.874.874 0 0 0 .94-.805.878.878 0 0 0-.802-.941ZM128.473 67.62l-3.243-.256a.875.875 0 0 0-.137 1.746l3.242.256a.878.878 0 0 0 .94-.805.878.878 0 0 0-.802-.941ZM134.461 68.092l-3.243-.255a.876.876 0 0 0-.138 1.746l3.243.255a.876.876 0 0 0 .138-1.746Z"
      />
      <path fill="#EBECF0" d="m76.046 54.17-.042.53 65.67 5.159.041-.53-65.67-5.16Z" />
      <g filter="url(#b)">
        <path
          fill="#F3F4F6"
          d="m142.665 51.588-.041.53-2.285-.18-24.351-1.913.044-.53 24.348 1.913 2.285.18Z"
        />
      </g>
      <path
        fill="#F4AEAE"
        d="M62.385 45.962s-3.555 15.01.79 15.01c4.345 0 14.615-16.985 14.615-16.985l-3.555-4.344-6.38 8.858-.335-4.514-5.135 1.975Z"
      />
      <path
        fill="#F4AEAE"
        d="M76.841 44.64a3.458 3.458 0 1 0 0-6.917 3.458 3.458 0 0 0 0 6.916Z"
      />
      <path
        fill="#121214"
        d="m71.187 33.322-2.37-2.37s-4.74 2.765-5.135 5.53c-.395 2.765-2.37 11.455-2.37 11.455l7.308.592 2.37-3.555.197-11.652Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h240.585v156H0z" />
      </clipPath>
      <filter
        id="b"
        width={34.678}
        height={10.622}
        x={111.988}
        y={49.495}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1744_13921" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1744_13921" result="shape" />
      </filter>
    </defs>
  </svg>
);

const TrackerIntroSlideThirdLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={145}
    fill="none"
    {...props}
    data-palette="TrackerIntroSlideThirdLight">
    <circle cx={91.819} cy={81.25} r={62.679} fill="#F3F4F6" />
    <circle cx={33.069} cy={38.929} r={3.929} fill="#F3F4F6" />
    <circle cx={34.318} cy={121.607} r={6.964} fill="#F3F4F6" />
    <circle cx={158.96} cy={114.822} r={6.964} fill="#F3F4F6" />
    <circle cx={145.389} cy={122.678} r={3.393} fill="#F3F4F6" />
    <path
      fill="#F3F4F6"
      d="m162.232 93.332 1.093 5.167 5.093 1.11-5.093 1.109-1.093 5.167-1.094-5.167-5.093-1.11 5.093-1.109 1.094-5.167ZM155.691 40.58c.08-.378.619-.378.699 0l.696 3.29a.357.357 0 0 0 .274.275l3.265.711c.375.082.375.616 0 .698l-3.265.712a.357.357 0 0 0-.274.275l-.696 3.29c-.08.377-.619.377-.699 0l-.697-3.29a.357.357 0 0 0-.273-.275l-3.266-.712c-.374-.082-.374-.616 0-.698l3.266-.711a.357.357 0 0 0 .273-.275l.697-3.29ZM26.005 83.793c.08-.377.618-.377.698 0l1.194 5.64c.03.138.136.246.274.275l5.582 1.216c.374.082.374.617 0 .698l-5.582 1.216a.357.357 0 0 0-.274.275l-1.194 5.64c-.08.378-.619.378-.698 0l-1.194-5.64a.357.357 0 0 0-.274-.275l-5.582-1.216c-.374-.081-.374-.616 0-.698l5.582-1.216a.357.357 0 0 0 .274-.275l1.194-5.64ZM48.255 23.763c-.207-.044-.207-.34 0-.384l3.131-.665a.196.196 0 0 0 .15-.15l.675-3.109c.045-.206.339-.206.383 0l.674 3.109a.196.196 0 0 0 .151.15l3.13.666c.208.044.208.339 0 .383l-3.13.666a.196.196 0 0 0-.15.15l-.675 3.109c-.044.206-.338.206-.383 0l-.674-3.109a.196.196 0 0 0-.151-.15l-3.13-.666Z"
    />
    <g clipPath="url(#a)">
      <path
        fill="#F3F4F6"
        d="M138.159 143.19H53.03a.265.265 0 0 1 0-.522h85.129a.264.264 0 0 1 0 .522Z"
      />
      <path fill="#E6E6E6" d="M238.883 7.564h-1.565v.261h1.565v-.26Z" />
      <path
        fill="#ADB1B7"
        d="M234.156 7.825h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.162v.26Zm-6.324 0h-3.161v-.26h3.162l-.001.26Zm-6.323 0h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.161l.001.26Zm-6.323 0h-3.164v-.26h3.162l.002.26Zm-6.324 0h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.161l.001.26Zm-6.323 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.161l.002.26Zm-6.324 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.161l.002.26Zm-6.323 0h-3.163v-.26h3.161l.002.26Z"
      />
      <path
        fill="#E6E6E6"
        d="M143.93 14.043h-1.565v.26h1.565v-.26ZM187.499 31.822h-1.565v.261h1.565v-.26Z"
      />
      <path
        fill="#ADB1B7"
        d="M182.818 32.083h-3.114v-.26h3.114v.26Zm-6.229 0h-3.115v-.26h3.115v.26Zm-6.229 0h-3.115v-.26h3.116l-.001.26Zm-6.23 0h-3.115v-.26h3.115v.26Zm-6.229 0h-3.115v-.26h3.114l.001.26Zm-6.23 0h-3.114v-.26h3.114v.26Zm-6.229 0h-3.115v-.26h3.115v.26Zm-6.229 0h-3.115v-.26h3.114l.001.26Z"
      />
      <path
        fill="#E6E6E6"
        d="M143.93 38.3h-1.565v.262h1.565V38.3ZM156.979 43.299h-1.565v.26h1.565v-.26Z"
      />
      <path
        fill="#ADB1B7"
        d="M152.21 43.56h-3.204v-.261h3.204v.26Zm-6.409 0h-3.204v-.261h3.204v.26Zm-6.409 0h-3.204v-.261h3.204v.26Z"
      />
      <path fill="#E6E6E6" d="M143.93 49.777h-1.565v.261h1.565v-.26Z" />
      <path
        fill="#FE6C02"
        d="M238.926 10.437v44.67a8.49 8.49 0 0 1-8.477 8.478h-90.772a8.456 8.456 0 0 1-6.304-2.817v-.4a8.195 8.195 0 0 0 6.252 2.956l15.7-15.7a2.218 2.218 0 0 1 3.135 0l8.345 8.342 19.56-19.558a2.214 2.214 0 0 1 3.135 0l11.474 11.472 37.433-37.43.258-.008.12-.003.141-.002Z"
      />
      <path
        fill="#ADB1B7"
        d="M230.536 63.644h-90.772a8.487 8.487 0 0 1-8.477-8.477V8.477A8.49 8.49 0 0 1 139.764 0h90.772a8.486 8.486 0 0 1 8.477 8.477v46.69a8.49 8.49 0 0 1-8.477 8.477ZM139.764.261a8.227 8.227 0 0 0-8.216 8.216v46.69a8.225 8.225 0 0 0 8.216 8.216h90.772a8.228 8.228 0 0 0 8.216-8.216V8.477a8.23 8.23 0 0 0-8.216-8.216h-90.772Z"
      />
      <path
        fill="#3F3D56"
        d="m139.856 63.606-.184-.184 15.74-15.741a2.217 2.217 0 0 1 3.135 0l8.344 8.344 19.56-19.56a2.22 2.22 0 0 1 3.136 0l11.474 11.474L238.79 10.21l.184.184L201.06 48.31l-11.659-11.66a1.955 1.955 0 0 0-2.766 0l-19.746 19.745-8.529-8.529a1.959 1.959 0 0 0-2.767 0l-15.737 15.74Z"
      />
      <path
        fill="#8E9298"
        d="M156.98 45.255a1.826 1.826 0 1 0 0-3.65 1.826 1.826 0 0 0 0 3.65ZM187.498 33.779a1.826 1.826 0 1 0 0-3.653 1.826 1.826 0 0 0 0 3.653ZM238.882 9.52a1.826 1.826 0 1 0 0-3.65 1.826 1.826 0 0 0 0 3.65Z"
      />
      <path
        fill="#F4AEAE"
        d="M92.387 34.74s.183 4.762-.916 5.861c-1.099 1.1 5.496 4.947 5.496 4.947l3.847-6.046s-1.465-2.564-1.1-4.763h-7.327ZM80.572 131.556v4.58l5.68.365-.366-4.946-5.314.001ZM111.714 131.556v4.58l-5.679.365.365-4.946 5.314.001Z"
      />
      <path
        fill="#ADB1B7"
        d="M83.503 80.812s-2.93 10.625-1.1 19.052c0 0 0 3.664.734 4.397.732.732.916.732.365 1.099-.551.366-1.649 1.282-1.1 1.832.55.549.733 1.282.366 1.465-.368.184-.733.55-.365 1.282.367.733-1.832 20.335-1.832 20.335s-2.198 2.381 0 2.565c2.198.183 5.862 1.099 6.228-.366.367-1.464 3.298-22.166 3.298-22.166s.365-.549 1.099-1.465.365-1.283.365-1.466c0-.183 3.85-17.588 3.85-17.588s5.678 19.785 6.228 20.151c.549.366.733.365.733.916s-.366.916 0 1.466c.2.294.383.6.549.916 0 0 .916 20.517 2.748 20.517 1.832 0 7.328-.365 6.778-2.015-.549-1.65-1.282-1.281-1.282-1.281s1.282-16.854-1.832-21.8v-4.031c0-.365.183-.55 0-.916-.183-.367.55-22.166-2.931-23.45-3.481-1.283-22.899.55-22.899.55Z"
      />
      <path
        fill="#121214"
        d="M84.052 134.854s-.916-1.465-2.198-1.465-2.198 1.465-2.198 1.465l-3.298 4.58s-4.763 2.931-2.93 4.58c1.831 1.649 6.777.733 6.777.733s4.03-2.931 4.58-3.115a11.677 11.677 0 0 0 2.198-1.282c.183-.183-.365-6.778-.916-6.32-.55.458-.915 1.923-2.015.824ZM108.234 134.854s.916-1.465 2.199-1.465c1.282 0 2.198 1.465 2.198 1.465l3.298 4.58s4.762 2.931 2.931 4.58c-1.832 1.649-6.779.733-6.779.733s-4.03-2.931-4.579-3.115a11.673 11.673 0 0 1-2.199-1.282c-.182-.183.366-6.778.916-6.32.551.458.916 1.923 2.015.824Z"
      />
      <path
        fill="#F4AEAE"
        d="M95.048 37.135a6.595 6.595 0 1 0 0-13.19 6.595 6.595 0 0 0 0 13.19Z"
      />
      <path
        fill="#121214"
        d="M93.853 41.151s-1.232.068-1.807-1.798l-9.734 7.11 4.03 10.81s.55 5.861 0 7.511c-.549 1.65-.915 2.931-.915 3.664 0 .733-3.847 13.007-2.382 13.556 1.466.55 23.815 2.748 24.365-.916.55-3.664-1.831-27.846-1.831-27.846l3.847-9.343-9.354-6.119s-.906 3.737-6.219 3.371Z"
      />
      <path
        fill="#F4AEAE"
        d="m81.673 58.097-.733 5.679s-2.93 6.045-2.198 14.105l-.183 5.313s-1.831 9.16 1.832 9.526c3.664.366 1.283-10.076 1.283-10.076l2.015-4.946 2.063-11.003 1.051-7.682-5.13-.916Z"
      />
      <path
        fill="#121214"
        d="m84.968 46.188-2.656.275s-1.74 12.915-1.191 12.915c.55 0 6.778 1.466 6.961 1.1.183-.367-3.114-14.29-3.114-14.29ZM90.505 24.04l-1.189-.431s2.486-2.486 5.944-2.27l-.972-.972s2.377-.865 4.538 1.405c1.136 1.193 2.452 2.595 3.271 4.175h1.273l-.532 1.063 1.86 1.062-1.909-.19a5.362 5.362 0 0 1-.18 2.752l-.432 1.189s-1.729-3.46-1.729-3.891v1.08s-1.189-.972-1.189-1.62l-.648.756-.324-1.19-4 1.19.65-.973-2.486.324.972-1.189s-2.81 1.405-2.918 2.594c-.108 1.189-1.513 2.702-1.513 2.702l-.648-1.08s-.973-4.864 2.161-6.485Z"
      />
      <path
        fill="#ADB1B7"
        d="M107.822 118c6.753 0 12.228-7.792 12.228-17.403 0-9.612-5.475-17.404-12.228-17.404-6.754 0-12.228 7.792-12.228 17.404 0 9.611 5.474 17.403 12.228 17.403Z"
      />
      <path
        fill="#E6E9EF"
        d="M109.47 118c6.754 0 12.228-7.792 12.228-17.403 0-9.612-5.474-17.404-12.228-17.404-6.753 0-12.228 7.792-12.228 17.404 0 9.611 5.475 17.403 12.228 17.403Z"
      />
      <path
        fill="#FE6C02"
        d="M109.379 107.786v-1.752a4.076 4.076 0 0 1-2.336-.763l.365-1.162a3.738 3.738 0 0 0 2.199.746c1.085 0 1.817-.711 1.817-1.7 0-.954-.595-1.544-1.725-2.065-1.558-.694-2.52-1.492-2.52-3.001a2.728 2.728 0 0 1 2.306-2.793v-1.752h.949v1.683c.706.01 1.394.22 1.985.607l-.382 1.145a3.372 3.372 0 0 0-1.924-.59c-1.176 0-1.619.798-1.619 1.492 0 .902.565 1.353 1.894 1.978 1.573.728 2.367 1.63 2.367 3.174a2.901 2.901 0 0 1-2.413 2.949v1.804h-.963Z"
      />
      <path
        fill="#F4AEAE"
        d="M112.081 56.081v7.512s.182 9.16-2.931 14.839l-1.649 3.662s-3.298 10.626-5.313 7.328c-2.015-3.297 2.199-8.793 2.199-8.793l2.384-13.944-1.468-9.321 6.778-1.283Z"
      />
      <path
        fill="#121214"
        d="m105.852 43.441 3.573.458s4.304 13.099 3.206 13.648c-1.098.55-8.242.916-8.242.916l1.463-15.022Z"
      />
      <path
        fill="#ADB1B7"
        d="M57.675 50.2H4.927A4.9 4.9 0 0 1 0 45.338V18.549a4.9 4.9 0 0 1 4.927-4.865h52.748a4.9 4.9 0 0 1 4.926 4.864v26.788a4.9 4.9 0 0 1-4.926 4.865ZM4.927 13.834a4.75 4.75 0 0 0-4.775 4.715v26.788a4.75 4.75 0 0 0 4.775 4.714h52.748a4.75 4.75 0 0 0 4.775-4.714V18.548a4.75 4.75 0 0 0-4.775-4.715H4.927Z"
      />
      <path
        fill="#5A606B"
        d="M40.69 18.9H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.153.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043A2.087 2.087 0 0 0 40.69 18.9Z"
      />
      <path
        fill="#E8B149"
        d="M6.678 23.751a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.957v3.165Z"
      />
      <path
        fill="#ADB1B7"
        d="M40.69 18.9H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.153.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043A2.087 2.087 0 0 0 40.69 18.9Z"
      />
      <path
        fill="#FE6C02"
        d="m45.908 24.172 2.27-2.315 1.035 1.056 5.399-1.183 3.816-2.253v4.695h-12.52ZM6.678 23.751a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.957v3.165Z"
      />
      <path
        fill="#5A606B"
        d="M40.69 29.855H13.563a2.087 2.087 0 0 0-2.086 2.087v1.044c0 1.152.934 2.086 2.086 2.086H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043a2.087 2.087 0 0 0-2.087-2.087Z"
      />
      <path
        fill="#E8B149"
        d="M6.678 34.706a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 1 1-.59.59l-.957-.956v3.164Z"
      />
      <path
        fill="#ADB1B7"
        d="M40.69 29.855H13.563a2.087 2.087 0 0 0-2.086 2.087v1.044c0 1.152.934 2.086 2.086 2.086H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043a2.087 2.087 0 0 0-2.087-2.087Z"
      />
      <path
        fill="#FE6C02"
        d="M6.678 34.706a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 1 1-.59.59l-.957-.956v3.164Z"
      />
      <path
        fill="#5A606B"
        d="M40.69 40.55H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.152.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.044a2.087 2.087 0 0 0-2.087-2.086Z"
      />
      <path
        fill="#E8B149"
        d="M6.678 45.4a.417.417 0 1 1-.835 0v-3.164l-.956.957a.418.418 0 1 1-.59-.591l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.956V45.4Z"
      />
      <path
        fill="#ADB1B7"
        d="M40.69 40.55H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.152.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.044a2.087 2.087 0 0 0-2.087-2.086Z"
      />
      <path
        fill="#FE6C02"
        d="M6.678 45.4a.417.417 0 1 1-.835 0v-3.164l-.956.957a.418.418 0 1 1-.59-.591l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.956V45.4ZM45.908 35.072l2.27-2.315 1.035 1.056 5.399-1.183 3.816-2.253v4.695h-12.52ZM45.908 45.766l2.27-2.314 1.035 1.055 5.399-1.183 3.816-2.253v4.695h-12.52Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h240.708v145H0z" />
      </clipPath>
    </defs>
  </svg>
);

const TrackerIntroSlideThirdDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={241}
    height={145}
    fill="none"
    {...props}
    data-palette="TrackerIntroSlideThirdDark">
    <circle cx={91.819} cy={81.25} r={62.679} fill="#22242C" />
    <circle cx={33.069} cy={38.929} r={3.929} fill="#22242C" />
    <circle cx={34.318} cy={121.607} r={6.964} fill="#22242C" />
    <circle cx={158.96} cy={114.822} r={6.964} fill="#22242C" />
    <circle cx={145.389} cy={122.678} r={3.393} fill="#22242C" />
    <path
      fill="#22242C"
      d="m162.232 93.332 1.093 5.167 5.093 1.11-5.093 1.109-1.093 5.167-1.094-5.167-5.093-1.11 5.093-1.109 1.094-5.167ZM155.691 40.58c.08-.378.619-.378.699 0l.696 3.29a.357.357 0 0 0 .274.275l3.265.711c.375.082.375.616 0 .698l-3.265.712a.357.357 0 0 0-.274.275l-.696 3.29c-.08.377-.619.377-.699 0l-.697-3.29a.357.357 0 0 0-.273-.275l-3.266-.712c-.374-.082-.374-.616 0-.698l3.266-.711a.357.357 0 0 0 .273-.275l.697-3.29ZM26.005 83.793c.08-.377.618-.377.698 0l1.194 5.64c.03.138.136.246.274.275l5.582 1.216c.374.082.374.617 0 .698l-5.582 1.216a.357.357 0 0 0-.274.275l-1.194 5.64c-.08.378-.619.378-.698 0l-1.194-5.64a.357.357 0 0 0-.274-.275l-5.582-1.216c-.374-.081-.374-.616 0-.698l5.582-1.216a.357.357 0 0 0 .274-.275l1.194-5.64ZM48.255 23.763c-.207-.044-.207-.34 0-.384l3.131-.665a.196.196 0 0 0 .15-.15l.675-3.109c.045-.206.339-.206.383 0l.674 3.109a.196.196 0 0 0 .151.15l3.13.666c.208.044.208.339 0 .383l-3.13.666a.196.196 0 0 0-.15.15l-.675 3.109c-.044.206-.338.206-.383 0l-.674-3.109a.196.196 0 0 0-.151-.15l-3.13-.666Z"
    />
    <g clipPath="url(#a)">
      <path
        fill="#22242C"
        d="M138.159 143.19H53.03a.265.265 0 0 1 0-.522h85.129a.264.264 0 0 1 0 .522Z"
      />
      <path fill="#E6E6E6" d="M238.883 7.564h-1.565v.261h1.565v-.26Z" />
      <path
        fill="#353845"
        d="M234.156 7.825h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.162v.26Zm-6.324 0h-3.161v-.26h3.162l-.001.26Zm-6.323 0h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.161l.001.26Zm-6.323 0h-3.164v-.26h3.162l.002.26Zm-6.324 0h-3.162v-.26h3.162v.26Zm-6.323 0h-3.162v-.26h3.161l.001.26Zm-6.323 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.161l.002.26Zm-6.324 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.162l.001.26Zm-6.323 0h-3.163v-.26h3.161l.002.26Zm-6.323 0h-3.163v-.26h3.161l.002.26Z"
      />
      <path
        fill="#E6E6E6"
        d="M143.93 14.043h-1.565v.26h1.565v-.26ZM187.499 31.822h-1.565v.261h1.565v-.26Z"
      />
      <path
        fill="#353845"
        d="M182.818 32.083h-3.114v-.26h3.114v.26Zm-6.229 0h-3.115v-.26h3.115v.26Zm-6.229 0h-3.115v-.26h3.116l-.001.26Zm-6.23 0h-3.115v-.26h3.115v.26Zm-6.229 0h-3.115v-.26h3.114l.001.26Zm-6.23 0h-3.114v-.26h3.114v.26Zm-6.229 0h-3.115v-.26h3.115v.26Zm-6.229 0h-3.115v-.26h3.114l.001.26Z"
      />
      <path
        fill="#E6E6E6"
        d="M143.93 38.3h-1.565v.262h1.565V38.3ZM156.979 43.299h-1.565v.26h1.565v-.26Z"
      />
      <path
        fill="#353845"
        d="M152.21 43.56h-3.204v-.261h3.204v.26Zm-6.409 0h-3.204v-.261h3.204v.26Zm-6.409 0h-3.204v-.261h3.204v.26Z"
      />
      <path fill="#E6E6E6" d="M143.93 49.777h-1.565v.261h1.565v-.26Z" />
      <path
        fill="#FE6C02"
        d="M238.926 10.437v44.67a8.49 8.49 0 0 1-8.477 8.478h-90.772a8.456 8.456 0 0 1-6.304-2.817v-.4a8.195 8.195 0 0 0 6.252 2.956l15.7-15.7a2.218 2.218 0 0 1 3.135 0l8.345 8.342 19.56-19.558a2.214 2.214 0 0 1 3.135 0l11.474 11.472 37.433-37.43.258-.008.12-.003.141-.002Z"
      />
      <path
        fill="#353845"
        d="M230.536 63.644h-90.772a8.487 8.487 0 0 1-8.477-8.477V8.477A8.49 8.49 0 0 1 139.764 0h90.772a8.486 8.486 0 0 1 8.477 8.477v46.69a8.49 8.49 0 0 1-8.477 8.477ZM139.764.261a8.227 8.227 0 0 0-8.216 8.216v46.69a8.225 8.225 0 0 0 8.216 8.216h90.772a8.228 8.228 0 0 0 8.216-8.216V8.477a8.23 8.23 0 0 0-8.216-8.216h-90.772Z"
      />
      <path
        fill="#3F3D56"
        d="m139.856 63.606-.184-.184 15.74-15.741a2.217 2.217 0 0 1 3.135 0l8.344 8.344 19.56-19.56a2.22 2.22 0 0 1 3.136 0l11.474 11.474L238.79 10.21l.184.184L201.06 48.31l-11.659-11.66a1.955 1.955 0 0 0-2.766 0l-19.746 19.745-8.529-8.529a1.959 1.959 0 0 0-2.767 0l-15.737 15.74Z"
      />
      <path
        fill="#2D303A"
        d="M156.98 45.255a1.826 1.826 0 1 0 0-3.65 1.826 1.826 0 0 0 0 3.65ZM187.498 33.779a1.826 1.826 0 1 0 0-3.653 1.826 1.826 0 0 0 0 3.653ZM238.882 9.52a1.826 1.826 0 1 0 0-3.65 1.826 1.826 0 0 0 0 3.65Z"
      />
      <path
        fill="#F4AEAE"
        d="M92.387 34.74s.183 4.762-.916 5.861c-1.099 1.1 5.496 4.947 5.496 4.947l3.847-6.046s-1.465-2.564-1.1-4.763h-7.327ZM80.572 131.556v4.58l5.68.365-.366-4.946-5.314.001ZM111.714 131.556v4.58l-5.679.365.365-4.946 5.314.001Z"
      />
      <path
        fill="#111114"
        d="M83.503 80.812s-2.93 10.625-1.1 19.052c0 0 0 3.664.734 4.397.732.732.916.732.365 1.099-.551.366-1.649 1.282-1.1 1.832.55.549.733 1.282.366 1.465-.368.184-.733.55-.365 1.282.367.733-1.832 20.335-1.832 20.335s-2.198 2.381 0 2.565c2.198.183 5.862 1.099 6.228-.366.367-1.464 3.298-22.166 3.298-22.166s.365-.549 1.099-1.465.365-1.283.365-1.466c0-.183 3.85-17.588 3.85-17.588s5.678 19.785 6.228 20.151c.549.366.733.365.733.916s-.366.916 0 1.466c.2.294.383.6.549.916 0 0 .916 20.517 2.748 20.517 1.832 0 7.328-.365 6.778-2.015-.549-1.65-1.282-1.281-1.282-1.281s1.282-16.854-1.832-21.8v-4.031c0-.365.183-.55 0-.916-.183-.367.55-22.166-2.931-23.45-3.481-1.283-22.899.55-22.899.55Z"
      />
      <path
        fill="#353845"
        d="M84.052 134.854s-.916-1.465-2.198-1.465-2.198 1.465-2.198 1.465l-3.298 4.58s-4.763 2.931-2.93 4.58c1.831 1.649 6.777.733 6.777.733s4.03-2.931 4.58-3.115a11.677 11.677 0 0 0 2.198-1.282c.183-.183-.365-6.778-.916-6.32-.55.458-.915 1.923-2.015.824ZM108.234 134.854s.916-1.465 2.199-1.465c1.282 0 2.198 1.465 2.198 1.465l3.298 4.58s4.762 2.931 2.931 4.58c-1.832 1.649-6.779.733-6.779.733s-4.03-2.931-4.579-3.115a11.673 11.673 0 0 1-2.199-1.282c-.182-.183.366-6.778.916-6.32.551.458.916 1.923 2.015.824Z"
      />
      <path
        fill="#F4AEAE"
        d="M95.048 37.135a6.595 6.595 0 1 0 0-13.19 6.595 6.595 0 0 0 0 13.19Z"
      />
      <path
        fill="#E1E1E2"
        d="M93.853 41.151s-1.232.068-1.807-1.798l-9.734 7.11 4.03 10.81s.55 5.861 0 7.511c-.549 1.65-.915 2.931-.915 3.664 0 .733-3.847 13.007-2.382 13.556 1.466.55 23.815 2.748 24.365-.916.55-3.664-1.831-27.846-1.831-27.846l3.847-9.343-9.354-6.119s-.906 3.737-6.219 3.371Z"
      />
      <path
        fill="#F4AEAE"
        d="m81.673 58.097-.733 5.679s-2.93 6.045-2.198 14.105l-.183 5.313s-1.831 9.16 1.832 9.526c3.664.366 1.283-10.076 1.283-10.076l2.015-4.946 2.063-11.003 1.051-7.682-5.13-.916Z"
      />
      <path
        fill="#E1E1E2"
        d="m84.968 46.188-2.656.275s-1.74 12.915-1.191 12.915c.55 0 6.778 1.466 6.961 1.1.183-.367-3.114-14.29-3.114-14.29Z"
      />
      <path
        fill="#353845"
        d="m90.505 24.04-1.189-.431s2.486-2.486 5.944-2.27l-.972-.972s2.377-.865 4.538 1.405c1.136 1.193 2.452 2.595 3.271 4.175h1.273l-.532 1.063 1.86 1.062-1.909-.19a5.362 5.362 0 0 1-.18 2.752l-.432 1.189s-1.729-3.46-1.729-3.891v1.08s-1.189-.972-1.189-1.62l-.648.756-.324-1.19-4 1.19.65-.973-2.486.324.972-1.189s-2.81 1.405-2.918 2.594c-.108 1.189-1.513 2.702-1.513 2.702l-.648-1.08s-.973-4.864 2.161-6.485ZM107.822 118c6.753 0 12.228-7.792 12.228-17.403 0-9.612-5.475-17.404-12.228-17.404-6.754 0-12.228 7.792-12.228 17.404 0 9.611 5.474 17.403 12.228 17.403Z"
      />
      <path
        fill="#2D303A"
        d="M109.47 118c6.754 0 12.228-7.792 12.228-17.403 0-9.612-5.474-17.404-12.228-17.404-6.753 0-12.228 7.792-12.228 17.404 0 9.611 5.475 17.403 12.228 17.403Z"
      />
      <path
        fill="#FE6C02"
        d="M109.379 107.786v-1.752a4.076 4.076 0 0 1-2.336-.763l.365-1.162a3.738 3.738 0 0 0 2.199.746c1.085 0 1.817-.711 1.817-1.7 0-.954-.595-1.544-1.725-2.065-1.558-.694-2.52-1.492-2.52-3.001a2.728 2.728 0 0 1 2.306-2.793v-1.752h.949v1.683c.706.01 1.394.22 1.985.607l-.382 1.145a3.372 3.372 0 0 0-1.924-.59c-1.176 0-1.619.798-1.619 1.492 0 .902.565 1.353 1.894 1.978 1.573.728 2.367 1.63 2.367 3.174a2.901 2.901 0 0 1-2.413 2.949v1.804h-.963Z"
      />
      <path
        fill="#F4AEAE"
        d="M112.081 56.081v7.512s.182 9.16-2.931 14.839l-1.649 3.662s-3.298 10.626-5.313 7.328c-2.015-3.297 2.199-8.793 2.199-8.793l2.384-13.944-1.468-9.321 6.778-1.283Z"
      />
      <path
        fill="#E1E1E2"
        d="m105.852 43.441 3.573.458s4.304 13.099 3.206 13.648c-1.098.55-8.242.916-8.242.916l1.463-15.022Z"
      />
      <path
        fill="#353845"
        d="M57.675 50.2H4.927A4.9 4.9 0 0 1 0 45.338V18.549a4.9 4.9 0 0 1 4.927-4.865h52.748a4.9 4.9 0 0 1 4.926 4.864v26.788a4.9 4.9 0 0 1-4.926 4.865ZM4.927 13.834a4.75 4.75 0 0 0-4.775 4.715v26.788a4.75 4.75 0 0 0 4.775 4.714h52.748a4.75 4.75 0 0 0 4.775-4.714V18.548a4.75 4.75 0 0 0-4.775-4.715H4.927Z"
      />
      <path
        fill="#5A606B"
        d="M40.69 18.9H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.153.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043A2.087 2.087 0 0 0 40.69 18.9Z"
      />
      <path
        fill="#E8B149"
        d="M6.678 23.751a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.957v3.165Z"
      />
      <path
        fill="#2D303A"
        d="M40.69 18.9H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.153.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043A2.087 2.087 0 0 0 40.69 18.9Z"
      />
      <path
        fill="#FE6C02"
        d="m45.908 24.172 2.27-2.315 1.035 1.056 5.399-1.183 3.816-2.253v4.695h-12.52ZM6.678 23.751a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.957v3.165Z"
      />
      <path
        fill="#5A606B"
        d="M40.69 29.855H13.563a2.087 2.087 0 0 0-2.086 2.087v1.044c0 1.152.934 2.086 2.086 2.086H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043a2.087 2.087 0 0 0-2.087-2.087Z"
      />
      <path
        fill="#E8B149"
        d="M6.678 34.706a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 1 1-.59.59l-.957-.956v3.164Z"
      />
      <path
        fill="#2D303A"
        d="M40.69 29.855H13.563a2.087 2.087 0 0 0-2.086 2.087v1.044c0 1.152.934 2.086 2.086 2.086H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.043a2.087 2.087 0 0 0-2.087-2.087Z"
      />
      <path
        fill="#FE6C02"
        d="M6.678 34.706a.417.417 0 0 1-.835 0v-3.165l-.956.957a.418.418 0 1 1-.59-.59l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 1 1-.59.59l-.957-.956v3.164Z"
      />
      <path
        fill="#5A606B"
        d="M40.69 40.55H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.152.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.044a2.087 2.087 0 0 0-2.087-2.086Z"
      />
      <path
        fill="#E8B149"
        d="M6.678 45.4a.417.417 0 1 1-.835 0v-3.164l-.956.957a.418.418 0 1 1-.59-.591l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.956V45.4Z"
      />
      <path
        fill="#2D303A"
        d="M40.69 40.55H13.563a2.087 2.087 0 0 0-2.086 2.087v1.043c0 1.152.934 2.087 2.086 2.087H40.69a2.087 2.087 0 0 0 2.087-2.087v-1.044a2.087 2.087 0 0 0-2.087-2.086Z"
      />
      <path
        fill="#FE6C02"
        d="M6.678 45.4a.417.417 0 1 1-.835 0v-3.164l-.956.957a.418.418 0 1 1-.59-.591l1.669-1.67a.417.417 0 0 1 .59 0l1.669 1.67a.418.418 0 0 1-.59.59l-.957-.956V45.4ZM45.908 35.072l2.27-2.315 1.035 1.056 5.399-1.183 3.816-2.253v4.695h-12.52ZM45.908 45.766l2.27-2.314 1.035 1.055 5.399-1.183 3.816-2.253v4.695h-12.52Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h240.708v145H0z" />
      </clipPath>
    </defs>
  </svg>
);

export {
  TrackerIntroSlideFirstDark,
  TrackerIntroSlideFirstLight,
  TrackerIntroSlideSecondDark,
  TrackerIntroSlideSecondLight,
  TrackerIntroSlideThirdDark,
  TrackerIntroSlideThirdLight,
};
